import React, { useEffect, useState } from "react";
import { Collapse, Image, Table, Typography, Space, Row, Col } from "antd";
import alpha from "color-alpha";
import styles from "../../../Components/ExpansionPanel/ExpansionPanel.module.scss";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import schedule from "@assets/KPMG/assets/schedule.png";
import mda from "@assets/KPMG/assets/mda.png";
import { FAQcard } from "~/Components/FAQ/FAQCard";
import { get, isEmpty } from "lodash";

const singleProject = [
  {
    title: "Upstream Phase",
    value: "IRR: 10,7%\nNPV: USD 33.87 Million",
  },
  {
    title: "Downstream Phase – DKI Jakarta",
    value: "IRR: 11,9%\nNPV: USD 23.14 Million",
  },
  {
    title: "Downstream Phase – Bekasi City",
    value: "IRR: 11,8%\nNPV: USD 12.89 Million",
  },
  {
    title: "Downstream Phase – Bekasi Regency",
    value: "IRR: 12,1%\nNPV: USD 28.71 Million",
  },
  {
    title: "Downstream Phase – Bogor Regency",
    value: "IRR: 11,7%\nNPV: USD 27.66 Million",
  },
  // {
  //   title: "Estimated Concession Period",
  //   value: "30 years including 2 years of construction (2 phases)",
  // },
];

const { Panel } = Collapse;

interface AccordionPanelProps {
  title: string;
  data: {
    title?: string;
    description?: string;
    sector?: string;
    location?: string;
    link?: string;
    value?: string | number;
  }[];
}

interface AccordionTableProps {
  panels: AccordionPanelProps[];
  isFaq?: boolean;
  item?: any;
}
const StyledIcon = styled(Icon)`
  height: 24px;
  width: 24px;
  padding: 5px;
  border-radius: 100% !important;
  const { Panel } = Collapse;
`;
const AccordionTable: React.FC<AccordionTableProps> = ({
  panels,
  isFaq,
  item,
}) => {
  console.log("rendering map component");
  if (item && item.map) {
    let element: any = document.getElementById("iframe1");
    if (element) {
      element.src = item.map;
    }
  }
  const renderMap = () => {
    setTimeout(() => {
      console.log("rendering", item.map);
      var iDiv = document.createElement("iframe");
      iDiv.id = "iframe1";
      iDiv.src = `${item.map}`;
      // ? item.map
      // : "https://maps.google.com/maps?q=Timor%20-%20Leste,&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed";
      let element: any = document.getElementById("anchor");
      if (element) {
        element.appendChild(iDiv);
      }
    }, 10);
  };

  const formatValue = (value: string | number) => {
    if (typeof value === "number") {
      return value.toLocaleString();
    }
    return value;
  };
  const [activePanel, setActivePanel] = useState(["0"]); // Initially set the first panel as active

  return (
    <Collapse
      defaultActiveKey={activePanel}
      accordion
      destroyInactivePanel
      expandIconPosition="end"
      style={{
        backgroundColor: "transparent",
        border: "none",
      }}
      className="drilldown-collapse"
      expandIcon={(props) => {
        return (
          <StyledIcon
            fontSize={20}
            fontWeight="bold"
            icon="akar-icons:chevron-down"
            style={{
              color: "#FD349C",
              background: alpha(styles.strawberry, 0.2),
            }}
            // {...props}
            rotate={props.isActive ? "180deg" : 0}
          />
        );
      }}
      onChange={(e) => {
        if (e === "pIndex-2") {
          // renderMap();
        }
      }}
    >
      {panels.map((panel: any, index) => {
        return (
          <Panel
            header={panel.title}
            className={"textMedium"}
            key={`pIndex-${index}`}
            style={{
              border: `2px solid #DEDDDC`,
              borderRadius: 8,
              marginBottom: 16,
              padding: 16,
            }}
          >
            {isFaq ? (
              <FAQcard data={panel.data} />
            ) : panel.key === 0 || panel.key === 3 ? (
              <Table
                dataSource={panel.data}
                columns={[
                  {
                    title: "Title",
                    dataIndex: "title",
                    key: "title",
                    render: (value: any, record: any) => (
                      <Typography.Text
                        className={"textSmall"}
                        style={{ color: "#636363" }}
                      >
                        {value}
                      </Typography.Text>
                    ),
                  },
                  {
                    title: "Value",
                    dataIndex: "value",
                    key: "value",
                    render: (value: any) => {
                      let irr = "";
                      let npv = "";
                      if (value && value.key) {
                        irr = get(value, "financialFeasibility.irr", "");
                        if (isEmpty(irr)) {
                          irr = "10.0";
                        }
                        npv = get(value, "financialFeasibility.npv", "");
                        if (isEmpty(npv)) {
                          npv = "33.87";
                        }
                      }
                      return (
                        <div style={{ maxWidth: 800 }}>
                          {typeof value === "object" && value.key === "1" && (
                            <div>
                              <Row>
                                {singleProject.map(
                                  (info: any, infoIndex: number) => {
                                    return (
                                      <Col span={8} key={`info${infoIndex}`}>
                                        <div style={{ marginBottom: 20 }}>
                                          <div style={{ marginBottom: 10 }}>
                                            <Typography.Text
                                              className={"textSmall"}
                                              style={{ color: "#1E49E2" }}
                                            >
                                              {info.title}
                                            </Typography.Text>
                                          </div>
                                          <div>
                                            {info.value &&
                                              info.value
                                                .split("\n")
                                                .map(
                                                  (
                                                    line: any,
                                                    index: number
                                                  ) => (
                                                    <div
                                                      key={`newvalue${index}`}
                                                    >
                                                      <Typography.Text
                                                        className={"textSmall"}
                                                        style={
                                                          {
                                                            // color: "#1E49E2",
                                                          }
                                                        }
                                                      >
                                                        {formatValue(line)}
                                                      </Typography.Text>
                                                    </div>
                                                  )
                                                )}
                                          </div>
                                        </div>
                                      </Col>
                                    );
                                  }
                                )}
                              </Row>
                            </div>
                          )}
                          {typeof value === "object" && value.key !== "1" && (
                            <div>
                              <div>
                                <Typography.Text
                                  className={"textSmall"}
                                  style={{ color: "#1E49E2" }}
                                >
                                  IRR : {`${irr}%`}
                                </Typography.Text>
                              </div>
                              <div key={`value${index}`}>
                                <Typography.Text
                                  className={"textSmall"}
                                  style={{ color: "#1E49E2" }}
                                >
                                  NPV : {`USD ${npv} Million`}
                                </Typography.Text>
                              </div>
                            </div>
                          )}
                          {typeof value === "string" &&
                            value
                              .split("\n")
                              .map((line: any, index: number) => (
                                <div key={`value${index}`}>
                                  <Typography.Text
                                    className={"textSmall"}
                                    style={{ color: "#1E49E2" }}
                                  >
                                    {formatValue(line)}
                                  </Typography.Text>
                                </div>
                              ))}
                        </div>
                      );
                    },
                  },
                ]}
                showHeader={false}
                pagination={false}
              />
            ) : panel.key === 1 ? (
              <Space direction="vertical">
                <Image src={schedule} preview={false} />
                <Image src={mda} preview={false} />
              </Space>
            ) : (
              panel.key === 2 && (
                <div>
                  {/* <div id="anchor"></div> */}
                  <div className="mapouter">
                    <div className="gmap_canvas">
                      <iframe
                        id="iframe1"
                        // src={get(item, "map")}
                        // src={`https://maps.google.com/maps${encodeURI("?q=Indonesia,Pameungpeuk&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed")}`}
                        // src="https://maps.google.com/maps?q=Timor%20-%20Leste,&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
                        // id="gmap_canvas"
                        src={`https://maps.google.com/maps?q=${item.map}&t=&z=20&ie=UTF8&iwloc=&output=embed`}
                        style={{ width: "100%", height: "450px" }}
                        loading="lazy"
                      ></iframe>
                    </div>
                  </div>
                  {/* <iframe
                src={
                  item.map
                    ? item.map
                    : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253840.49131649232!2d106.66470446328029!3d-6.229720928728279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3e945e34b9d%3A0x5371bf0fdad786a2!2sJakarta%2C%20Indonesia!5e0!3m2!1sen!2sin!4v1684888991041!5m2!1sen!2sin"
                }
                width="100%"
                height="450"
                loading="lazy"
              ></iframe> */}
                </div>
              )
            )}
          </Panel>
        );
      })}
    </Collapse>
  );
};

export default AccordionTable;
